import TagManager from "react-gtm-module";

export const GtmInitialize = () => {
  const gtmInit = {
      gtmId: 'GTM-WTL6J5'
  };

  TagManager.initialize(gtmInit);
};

export const TrackSparePartsPageView = (categoryLevel1) => {
  const gtmEvent = {
    dataLayer: {
      pageName: "Category Home",
      categoryLevel1: categoryLevel1,
    },
  };

  TagManager.dataLayer(gtmEvent);
};

export const getTagManager = () => {
  return TagManager;
};

export const gtmUserLogged = (log, user) => {
  const tagManagerArgs = {
    dataLayer: {
      isLogged: log,
      userId: user,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
};

export const TrackEvent = (
  eventCategory,
  eventAction,
  eventLabel,
  eventLabel2
) => {
  const gtmEvent = {
    dataLayer: {
      event: "trackEvent",
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
    },
  };
  if (eventLabel2) {
    gtmEvent.dataLayer["eventLabel2"] = eventLabel2;
  }
  TagManager.dataLayer(gtmEvent);
};

export const TrackCustomEvent = (
  event,
  eventCategory,
  eventAction,
  eventLabel
) => {
  const gtmEvent = {
    dataLayer: {
      event: event,
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
    },
  };
  TagManager.dataLayer(gtmEvent);
};

export const manageGTMClick = (name, cat, posLabel, position) => {
  const tagManagerArgs = {
    dataLayer: {
      event: "promotionClick",
      ecommerce: {
        promoClick: {
          promotions: [
            {
              id: "Home Repuestos-Sucursales Online",
              name: name,
              creative: cat,
              position: `promocion ${posLabel}-${position + 1}`,
            },
          ],
        },
      },
    },
  };
  TagManager.dataLayer(tagManagerArgs);
};

export const searchBoxGTMClick = (radioChecked, boxStates, categoryName) => {
  const tagManagerArgs = {
    dataLayer: {
      event: "trackEventSearch",
      eventCategory: "Busqueda",
      searchBy: `${radioChecked == "radio1" ? "Maquinaria" : "Repuestos"}`,
      // searchResults: '{Con resultados|Sin resultados}', piece of info not available
      categoryLevel1: `${
        radioChecked == "radio1"
          ? boxStates[0].selectedOption.Label
          : categoryName
      }`,
      categoryLevel2: `${
        radioChecked == "radio1"
          ? boxStates[1].selectedOption.Label
          : boxStates[0].selectedOption
          ? boxStates[0].selectedOption.Label
          : "undefined"
      }`,
      categoryLevel3: `${
        radioChecked == "radio1"
          ? "undefined"
          : boxStates[1].selectedOption
          ? boxStates[1].selectedOption.Label
          : "undefined"
      }`,
      brand: `${
        boxStates[2].selectedOption
          ? boxStates[2].selectedOption.Label
          : "undefined"
      }-${
        boxStates[3].selectedOption
          ? boxStates[3].selectedOption.Label
          : "undefined"
      }`,
    },
  };
  TagManager.dataLayer(tagManagerArgs);
};

export const manageGTMImpression = (items, cat, promoPosition) => {
  let promotions = [];
  items.map((item, position) => {
    promotions.push({
      id: "Home Repuestos-Sucursales Online",
      name: item.Name,
      creative: cat,
      position: `promocion ${promoPosition}-${position + 1}`,
    });
  });

  const tagManagerArgs = {
    dataLayer: {
      event: "promotionImpression",
      ecommerce: {
        promoView: {
          promotions,
        },
      },
    },
  };
  TagManager.dataLayer(tagManagerArgs);
};

let dataLayerPushedProducts = [];

export const gtmProductImpressions = (items, startIndex, title) => {
  let impressions = [];
  let newDLPP = [...dataLayerPushedProducts];
  items.map((product, position) => {
    if (!dataLayerPushedProducts.includes(startIndex + position)) {
      impressions.push({
        id: product.Id,
        name: `${product.name}/${getModelType(product)}`,
        brand: getBrand(product),
        price: product.usdPrice,
        price_type: product.shows_reference_price ? 'Reference' : 'Fix',
        category: getCategoryPath(product),
        variant:
          product.company_name +
          (product.membership_name == null
            ? ""
            : "-" + product.membership_name) +
          (product.subpack_name == null ? "" : "-" + product.subpack_name) +
          (product.id_cliente == null 
            ? "" 
            : "/" + product.id_cliente),
        position: startIndex + position + 1,
        list: `Home Repuestos-${title}`,
        modelType: getModelType(product),
        dimension2: product.id_cliente,
        CDOid: 1,
      });
      newDLPP.push(startIndex + position);
    }
  });

  if (impressions.length) {
    const tagManagerArgs = {
      dataLayer: {
        event: "productImpression",
        ecommerce: {
          currencyCode: "USD",
          impressions,
        },
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  }
  dataLayerPushedProducts = newDLPP;
};

export const gtmProductClick = (product, position, title) => {
  const marca = getBrand(product);
  const categoryPath = getCategoryPath(product);

  const gtmProductClick = {
    dataLayer: {
      event: "productClick",
      ecommerce: {
        click: {
          actionField: {
            list: `Home Repuestos-${title}`,
          },
          products: [
            {
              id: product.Id,
              name: `${product.name}/${getModelType(product)}`,
              brand: marca,
              price: product.usdPrice,
              price_type: product.shows_reference_price ? 'Reference' : 'Fix',
              category: categoryPath,
              variant:
                product.company_name +
                (product.membership_name == null
                  ? ""
                  : "-" + product.membership_name) +
                (product.subpack_name == null
                  ? ""
                  : "-" + product.subpack_name) + 
                (product.id_cliente == null 
                  ? "" 
                  : "/" + product.id_cliente),
              position: position + 1,
              list: `Home Repuestos-${title}`,
              modelType: getModelType(product),
              dimension2: product.id_cliente,
              CDOid: 1,
            },
          ],
        },
      },
    },
  };

  TagManager.dataLayer(gtmProductClick);
};

const getCategoryPath = (item) => {
  var category =
    (item.main_category_name && item.main_category_name != item.categoryname
      ? item.main_category_name.trim() + "/"
      : "") +
    (item.submain_category_name &&
    item.submain_category_name != item.categoryname
      ? item.submain_category_name.trim() + "/"
      : "") +
    (item.categoryname ? item.categoryname.trim() : "");
  var cantCat = category.split("/").length;
  if (cantCat == 1) {
    category = category + "/No N2 category/No N3 category";
  } else if (cantCat == 2) {
    category = category + "/No N3 category";
  }

  category += item.condicion ? "/" + item.condicion : "/Not set";
  category += item.finalidad ? "/" + item.finalidad : "/Not set";
  return category;
};

const getList = (listingType, listingBaseName) => {
  switch (listingType) {
    case "categories":
      return (
        "Resultados de búsqueda-" + (listingBaseName ? listingBaseName : "")
      );
    case "search":
      return "Resultados de búsqueda-query";
    case "agroshop":
      return "Merchant-" + (listingBaseName ? listingBaseName : "");
    default:
      return null;
  }
};

const getModelType = (product) => {
  return product.IsCheckoutForm && product.usdPrice !== 0
    ? "Transactional"
    : product.IsQuotable
    ? "Quotable"
    : "No transactional";
};

const getBrand = (item) => {
  if (item.marca && item.brand_is_alternative) {
    return item.marca;
  } else if (item.marcas_dropdown) {
    return item.marcas_dropdown;
  } else if (item.marca_herramientas) {
    return item.marca_herramientas;
  } else if (item.marca_infraestructura) {
    return item.marca_infraestructura;
  } else if (item.marca_insumos) {
    return item.marca_insumos;
  } else if (item.marca_generadores) {
    return item.marca_generadores;
  } else if (item.company_name) {
    return item.company_name;
  } else {
    return "No definido";
  }
};

export const TrackPaymentMethodsPageView = () => {
  const gtmEvent = {
    dataLayer: {
      pageName: "Payment methods info"
    },
  };
  TagManager.dataLayer(gtmEvent);
};

export const TrackPaymentMethodClick = (option) => {
  const gtmEvent = {
    dataLayer: {
      event: "select_content",
      content_type: "Payment methods options",
      item_id: option,
    },
  };
  TagManager.dataLayer(gtmEvent);
};
